// extracted by mini-css-extract-plugin
module.exports = {"container":"OrderItemList_container__VGx9f","container__total":"OrderItemList_container__total__2_XWM"};